exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-section[data-v-c318c2a4]{max-width:100vw;background-color:#000;color:#fff;letter-spacing:2px;padding:50px 30px}.info-section .img-container-flex[data-v-c318c2a4]{display:flex;justify-content:center}.info-section .img-container-flex .img-container[data-v-c318c2a4]{padding:20px}.info-section .img-container-flex .img-container .my-photo[data-v-c318c2a4]{width:200px;height:auto;overflow:hidden}.info-section .info-text[data-v-c318c2a4]{font-size:1rem}.info-section .skill-icon-container[data-v-c318c2a4]{padding-top:30px}.info-section .skill-icon-container .skill-text[data-v-c318c2a4]{width:100vw;text-align:center}.info-section .skill-icon-container .skill-icon[data-v-c318c2a4]{width:50px;margin:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c318c2a4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Info.vue
// module id = 41
// module chunks = 0